export interface Tracking {
  title: string;
  description: string;
  date: string;
  pointId: number;
  alert: string | null;
}

export interface TrackingBaseResponse {
  trackingNumber: string;
  pickitNumber: string;
  tracking: Tracking[];
  title: string;
  statusTransaction: number;
  retailerName: string;
  transaction: {
    status: string;
    workflowTag: string;
    operationType: number;
    destination: Location;
    origin: Location;
    logisticSolutionType: string;
    deliveryPromiseTime?: string;
  };
}

export type PointInfo = {
  name: string;
  latitude: number;
  longitude: number;
};

export type TrackingState = {
  trackingInfo: TrackingBaseResponse;
  isDirty: boolean;
  pickitCode: string;
  token?: string;
  pointInfo?: PointInfo;
};

export enum Status {
  Pending = 'pending',
  Live = 'live',
}

export type Point = {
  name: string | null;
};

export type Address = {
  street: string;
  streetNumber: string;
  postalCode: string;
};

export interface Location {
  point: Point;
  address: Address;
}
